import React from 'react';
import { Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material';

import { AngleField, DistanceField } from '@paragon/material';
import { formatAsNaturalLanguageList, naturalSortByProperty } from '@paragon/utilities';

import { dropTopChords } from '../../../../store/actions/insertActions';
import { getActiveComponent } from '../../../../store/selectors/getActiveComponentSelector';
import { getFlatTopChordGuids } from '../../../../store/selectors/getFlatTopChordGuidsSelector';
import { getSelectedItemEntries } from '../../../../store/selectors/getSelectedItemSelector';
import { editDropTopChordsInsertion } from '../../../../store/slices/applicationSlice';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import InsertionPanelContainer from './InsertionPanelContainer';

export function DropTopChordsInsertionSubPanel() {
  const dispatch = useAppDispatch();

  const insertingObjectInfo = useAppSelector((state) => state.application.insertingObjectInfo);
  const selectedItems = useAppSelector(getSelectedItemEntries);
  const activeComponent = useAppSelector(getActiveComponent);
  const flatTopChordGuids = useAppSelector(getFlatTopChordGuids);

  if (insertingObjectInfo?.type !== 'droppedTopChords' || !activeComponent) return null;

  const { angle, thickness, fullyCrossing } = insertingObjectInfo;

  const topChordsToDrop = naturalSortByProperty(
    selectedItems
      .filter((item) => item.type === 'member')
      .map(({ item }) => item)
      .filter(({ guid }) => flatTopChordGuids.includes(guid)),
    (member) => member.name,
  );

  const selectedChordsText = topChordsToDrop.length
    ? `Dropping ${formatAsNaturalLanguageList(
        topChordsToDrop.map(({ name }) => name),
        '&',
      )}`
    : 'Select flat top chords to drop';

  return (
    <InsertionPanelContainer
      insertButtonText="Drop"
      disabled={topChordsToDrop.length === 0}
      onInsert={() => dispatch(dropTopChords(topChordsToDrop))}
    >
      <Box sx={{ padding: 1, marginBottom: 2 }}>
        <Typography align="center" variant="h5" sx={{ marginBottom: 2 }}>
          Drop Flat Top Chords
        </Typography>

        <Typography align="center" sx={{ marginBottom: 2 }}>
          {selectedChordsText}
        </Typography>

        <Stack direction="column" spacing={2}>
          <AngleField
            defaultDisplayFormat="slope"
            label="Crossing Slope"
            value={angle}
            onSubmit={(angle) => void dispatch(editDropTopChordsInsertion({ angle }))}
          />

          <DistanceField
            label="Lay-In/Purlin Thickness"
            value={thickness}
            onSubmit={(thickness) => void dispatch(editDropTopChordsInsertion({ thickness }))}
          />

          <FormControlLabel
            label="Supports End Of Lay-In/Purlin"
            control={
              <Checkbox
                checked={!fullyCrossing}
                onChange={(event) => dispatch(editDropTopChordsInsertion({ fullyCrossing: !event.target.checked }))}
              />
            }
          />
        </Stack>
      </Box>
    </InsertionPanelContainer>
  );
}
